<div class="toast fade show position-relative my-1" data-bs-autohide="true">
  @if (notification().title) {
    <div class="toast-header">
      @if (notification().icon) {
        <lucide-icon [name]="notification().icon" class="me-1"></lucide-icon>
      }
      @if (notification().title) {
        <strong class="ms-1 me-auto">{{ notification().title }}</strong>
      }

      @if (notification().dismissable) {
        <button type="button"
                class="btn-close"
                aria-label="Dismiss notification"
                (click)="dismiss()">
          <lucide-icon [img]="icons.close" [size]="40"></lucide-icon>
        </button>
      }
<!--      <small>11 mins ago</small>-->
    </div>
  }
  <div class="toast-body">
    @if (!notification().title && notification().icon) {
      <lucide-icon [name]="notification().icon" class="me-1"></lucide-icon>
    }
    {{ notification().message }}
    @if (!notification().title && notification().dismissable) {
      <button type="button"
              class="ms-auto btn-close"
              aria-label="Dismiss notification"
              (click)="dismiss()">
        <lucide-icon [img]="icons.close"></lucide-icon>
      </button>
    }
  </div>
</div>
